(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.view
  (:require
   [common.localization :as loc]
   [frontend.ui.component.file-input.core :as file-input]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.tab-layout.view :as tab-layout]
   [frontend.ui.page.lp-report-editor.common.event :as common-event]
   [frontend.ui.page.lp-report-editor.common.modal.pdf-preview-modal :as pdf-preview-modal]
   [frontend.ui.page.lp-report-editor.common.view :refer
    [continue-button footer next-button preview-pdf-button]]
   [frontend.ui.page.lp-report-editor.event :as editor-event]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.event :as event]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.feeder-report.view :as feeder-report]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.fund-report.view :as fund-report]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.holding-report.view :as holding-report]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.modal.upload-modal :as upload-modal]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.style :as style]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.sub :as sub]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.tabs.feeders-tab :as feeders-tab]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.tabs.fund-tab :as fund-tab]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.tabs.holdings-tab :as holdings-tab]
   [frontend.ui.page.lp-report-editor.style :as editor-style]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [frontend.utils :as fu]
   [herb.core :refer [<class]]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]))

(defn step-footer
  [main-report selected-report feeder-tab?]
  (let [reports-not-approved? @(rf/subscribe [::editor-sub/reports-not-approved?])]
    [footer
     {:left-content
      [:<>
       [continue-button]
       [:div
        [pdf-preview-modal/view
         {:on-close #(rf/dispatch [::common-event/close-pdf-preview])
          :report   selected-report
          :feeder?  feeder-tab?}]
        [preview-pdf-button
         {:on-click #(rf/dispatch [::common-event/open-pdf-preview selected-report feeder-tab?])}]]]
      :right-content
      [:<>
       (when @(rf/subscribe [::editor-sub/full-access?])
         [:div.flex.gap-3
          (if (= :lp-report.step/data-gathering (:lp-report/step main-report))
            [button/primary-solid
             {:disabled? (boolean reports-not-approved?)
              :on-click  #(rf/dispatch [::event/submit-cycle-for-review (:db/id main-report)])}
             (loc/tr :submit-for-review)]
            [next-button [::editor-event/activate-step :lp-report.step/review]])])]}]))

(defn report-listings
  []
  (let [report @(rf/subscribe [::editor-sub/lp-report])
        master-report-id (:db/id report)
        holdings @(rf/subscribe [::editor-sub/lp-report-holdings])
        feeders @(rf/subscribe [::editor-sub/feeder-reports])
        feeder-id (:db/id (first feeders))
        accessible-tabs (concat []
                                (when @(rf/subscribe [::editor-sub/master-report-access?])
                                  [:fund])
                                (when @(rf/subscribe [::editor-sub/holdings-access?])
                                  [:holdings])
                                (when (and @(rf/subscribe [::editor-sub/feeder-access?])
                                           (seq @(rf/subscribe [::editor-sub/feeder-reports])))
                                  [:feeders]))
        selected-tab @(rf/subscribe [::sub/selected-tab accessible-tabs])
        shown-tab (some #{selected-tab} accessible-tabs)
        can-upload-data? (case selected-tab
                           :feeders @(rf/subscribe [::sub/can-update-feeder-data?])
                           :fund @(rf/subscribe [::sub/can-update-report-data?])
                           @(rf/subscribe [::sub/can-edit-any-holdings-data?]))
        upload-report-data
        (fn [file]
          (let [target-report-id (if (= :feeders selected-tab)
                                   feeder-id
                                   master-report-id)
                can-update-data? (case selected-tab
                                   :feeders @(rf/subscribe [::sub/can-update-feeder-data?])
                                   :fund @(rf/subscribe [::sub/can-update-report-data?])
                                   @(rf/subscribe [::sub/can-edit-any-holdings-data?]))]
            (when can-update-data?
              (rf/dispatch [::event/start-upload file])
              (file-input/dispatch-upload-file
               {:owning-entity-id            target-report-id
                :owning-entity-ref-path      [:lp-report-editor :lp-report]
                :attachments-ref-path        [:lp-report-editor :lp-report-attachments]
                :dispatch-on-upload-success  [(case shown-tab
                                                :fund
                                                ::event/process-fund-report-data-only-file
                                                :feeders
                                                ::event/process-feeder-report-file
                                                :holdings
                                                ::event/process-holding-report-file)
                                              file
                                              target-report-id
                                              master-report-id
                                              [::event/end-upload file]
                                              [::event/error-upload file]]
                :dispatch-on-upload-progress [::event/upload-progress file]}
               file))))
        input-id (str ::file-input)

        show-tabs? (< 1 (count accessible-tabs))]
    [:<>
     [:div
      {:class        (<class editor-style/page-body)
       :on-drag-over fu/prevent-default-event!
       :on-change    (fn [e]
                       (fu/prevent-default-event! e)
                       (doseq [file (.. e -target -files)]
                         (upload-report-data file)))
       :on-drop      (fn [e]
                       (fu/prevent-default-event! e)
                       (doseq [file (.. e -dataTransfer -files)]
                         (upload-report-data file)))}
      [upload-modal/view [::sub/ongoing-uploads] [::event/hide-uploads]]
      (when can-upload-data?
        [:input
         {:id     input-id
          :type   "file"
          :accept [".xlsx"]
          :class  (<class style/upload-input)}])

      [grid/container {:breakpoint :xlarge}
       (when show-tabs?
         [tab-layout/tab-layout
          {:selected      selected-tab
           :on-tab-change (fn [k]
                            (rf/dispatch [::event/change-tab k]))}
          (merge {}
                 (when (some #{:fund} accessible-tabs)
                   {:fund {:title (loc/tr :lp-report-fund)}})
                 (when (some #{:holdings} accessible-tabs)
                   {:holdings {:title (loc/tr :lp-report-holdings)}})
                 (when (some #{:feeders} accessible-tabs)
                   {:feeders {:title (loc/tr :lp-report-feeders)}}))])
       (case shown-tab
         :fund [fund-tab/fund-view report input-id]
         :holdings [holdings-tab/view report holdings input-id]
         :feeders [feeders-tab/fund-view report (first feeders) input-id]
         [:div (str "NO ACCESS to any tabs " shown-tab)])]]
     [step-footer
      report
      (if (= selected-tab :feeders)
        (first feeders)
        report)
      (= selected-tab :feeders)]]))

(defn body
  [{:keys [report-id fund-ui-data feeder-ui-data ui-data-by-holding]}]
  (rf/dispatch [::event/reset-if-different-report report-id])
  (rf/dispatch [::event/init-rich-content-list fund-ui-data feeder-ui-data ui-data-by-holding])
  (fn []
    (let [gathering-mode @(rf/subscribe [::sub/gathering-mode])]
      (case gathering-mode
        :fund-report-editor
        [fund-report/view]

        :holding-report-editor
        [holding-report/view]

        :feeder-report-editor
        [feeder-report/view]

        [report-listings]))))
